import type { SingleSourceForm } from "../../api/singleSource";

/** Procurement officers, admins or the form's creator may edit / resubmit a DRAFT or REJECTED form. */
export function canEditSingleSourceForm(
  form: Pick<SingleSourceForm, "status" | "submittedBy"> | undefined,
  user: { id?: string; role?: string } | null | undefined
): boolean {
  if (!form || !user) return false;
  if (form.status !== "DRAFT" && form.status !== "REJECTED") return false;
  return (
    user.role === "PROCUREMENT_OFFICER" ||
    user.role === "ADMIN" ||
    (!!user.id && form.submittedBy === user.id)
  );
}
